import ScoreBoard from './ScoreBoard.component';

export default ScoreBoard;
